import EChartsController from "../echarts_controller"

export default class extends EChartsController {
  static values = {
    data: { type: Array, default: [] },
  }

  chartTargetConnected(target) {
    super.chartTargetConnected(target)
    this.renderChart(this.chart, this.dataValue)
  }

  renderChart(chart, data) {
    const option = {
      tooltip: {
        trigger: "item",
        confine: true,
      },
      grid: {
        left: "1%",
        top: "2%",
        right: "1%",
        bottom: "2%",
        containLabel: true,
      },
      xAxis: {
        type: "value",
        minInterval: 1,
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: { show: false },
        axisLabel: {
          color: "#B6C7D8",
          fontSize: 14,
          fontWeight: "500",
        },
      },
      yAxis: {
        type: "category",
        inverse: true,
        data: data.map((item) => item.name),
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: {
          color: "#F3F3F3",
          fontSize: 18,
          fontWeight: 500,
          margin: 20,
        },
      },
      series: [
        {
          type: "bar",
          data: data.map((item) => ({
            value: item.events_count,
            itemStyle: {
              color: item.color,
              borderRadius: [0, 10, 10, 0],
            },
          })),
          barWidth: 24,
          label: {
            show: false,
          },
        },
      ],
    }

    chart.setOption(option)
  }
}
